
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"2500","viewBox":"0.243 0.265 243.323 243.581","width":"2500","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#8e75ff","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M161.893 165.833v-78.73a5.077 5.077 0 00-5.077-5.076H78.178V.76h159.815a5.077 5.077 0 015.078 5.077v159.996z"}}),_c('path',{attrs:{"d":"M78.178.76v81.267H3.124a2.539 2.539 0 01-1.796-4.333zm83.715 240.206v-75.133h81.178l-76.844 76.927a2.539 2.539 0 01-4.334-1.794zM78.178 82.027h81.176a2.539 2.539 0 012.539 2.538v81.268H83.255a5.077 5.077 0 01-5.077-5.077z","opacity":".405"}})])])
          )
        }
      }
    